import { useEffect, useState } from 'react';
import './ConditionalNote.css';
import { useSnackBar } from '../../../../hooks/useSnackBar';
import { createInterchangeability } from '../../services/InterchangeabilityService';
import { Checkbox } from '@mui/material';

export const ConditionalNote = ({ item, onClose, handleResponse, groupType, editing }) => {
    const [inputValue, setInputValue] = useState('');
    const [debouncedValue, setDebouncedValue] = useState('');


    const handleChange = (event) => {
        setInputValue(event.target.value);
    };

    const { successMsg, warningMsg, infoMsg } = useSnackBar();

    const onSave = () => {
        infoMsg("Updating Interchangeability");
        createInterchangeability(1, [{ ...item, conditionalNote: debouncedValue }]).then(response => {
            if (response.data.responseCode === 204) {
                successMsg("Interchangeability updated", `Conditional Notes Updated`);
                handleResponse(response.data.load);
                // updateSections(prev => ({
                //   ...prev,
                //   [sourceType]: prev[sourceType].filter(i => i.id !== item.id),
                //   [type]: [item, ...prev[type]]
                // }))
            } else {
                warningMsg("Something went wrong");
            }
        }).catch(error => warningMsg("Something went wrong"))
    }


    useEffect(() => {
        const handler = setTimeout(() => {
            setDebouncedValue(inputValue);
        }, 500); // 500ms delay

        return () => {
            clearTimeout(handler);
        };
    }, [inputValue]);

    return (<div className='conditional-note-component'>
        <div className='header'>
            <div className='left'>
                <i className={`icon-${item.bothWays ? 'two-way' : 'one-way'}`}></i>
                <b>{groupType}</b>
            </div>

            <button className='outlined icon small-size' onClick={onClose}>
                <i className='icon-cross'></i>
            </button>
        </div>

        <div className='part'>
            <Checkbox disableRipple checked={true} />
            <b>{item.part.partNumber}</b>
            <span>{item.part.description}</span>
            <span>{item.part.ata}</span>
        </div>

        <div className='label'>
            <i className='icon-notes'></i>
            <b> Conditional Notes </b>

        </div>

        {editing ? <textarea defaultValue={item.conditionalNote ?? ""} onChange={handleChange} /> : (
            Boolean(item.conditionalNote) ?
            <div className='txt'>{item.conditionalNote}</div>:
            <div className='placeholder'>
                <i>No conditional notes for this intercchangeability.</i>
            </div>
        )}
        <div className='button-container'>

            {editing && <button onClick={onSave} className='filled small-size iconTextButton'>
                <i className='icon-save'></i>
                <span>Save</span>
            </button>}
        </div>


    </div>)
}